import React from 'react';

export const BrandsSection = () => {
  const brandLogos = [
    {
      id: 1,
      name: 'Image King',
      logo: 'https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/em3xh1st_ImageKing%20Logo%20whatsapp%20community.jpg'
    },
    {
      id: 2,
      name: 'Canon',
      logo: 'https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/4084qqny_Canon.jpg'
    },
    {
      id: 3,
      name: 'Epson',
      logo: 'https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/v24j8xn2_epson.png'
    },
    {
      id: 4,
      name: 'HP',
      logo: 'https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/q7cdd6pg_HP.jpg'
    },
    {
      id: 5,
      name: 'Brother',
      logo: 'https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/j4sez5hq_brother.png'
    },
    {
      id: 6,
      name: 'TVS Electronics',
      logo: 'https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/mushuinu_tvse.png'
    }
  ];

  // Duplicate the array multiple times for seamless infinite scroll
  const duplicatedBrands = [...brandLogos, ...brandLogos, ...brandLogos, ...brandLogos];

  return (
    <section id="brands" className="py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-blue-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        {/* Section Header */}
        <div className="text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Trusted Global Brands
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Authorized distributor for genuine consumables from world-leading printer manufacturers
          </p>
        </div>
      </div>

      {/* Scrolling Brand Logos */}
      <div className="relative w-full">
        {/* Gradient overlays for fade effect */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-blue-50 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-blue-50 to-transparent z-10 pointer-events-none"></div>
        
        {/* Marquee Container */}
        <div className="flex marquee-track">
          {duplicatedBrands.map((brand, index) => (
            <div
              key={`${brand.id}-${index}`}
              className="flex-shrink-0 mx-8 group"
            >
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-shadow duration-300 w-48 h-32 flex items-center justify-center border border-gray-100">
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="max-h-20 max-w-full object-contain group-hover:scale-110 transition-transform duration-300"
                  data-testid={`brand-logo-${brand.name.toLowerCase().replace(' ', '-')}`}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Brand Names */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
        <div className="text-center">
          <p className="text-gray-700 text-lg font-medium">
            Genuine OEM products from <span className="font-bold text-blue-900">Epson, Canon, HP, Brother, Image King</span> and <span className="font-bold text-blue-900">TVS Electronics</span>
          </p>
        </div>
      </div>
    </section>
  );
};
